import * as jQuery from "jquery";
import { IMusicMenuState } from "source/app/presentation/Header/Tools/Sound/Music/IMusicMenuState";
import { ILogInputFormState } from "source/app/presentation/MainPanel/Log/LogInputForm/LogInputForm";
import Ambience from "source/app/services/Sound/Ambience/Ambience";
import HowlAudioProvider from "source/app/services/Sound/AudioProvider/HowlAudioProvider";
import { SetLogEntrySound } from "source/app/services/Sound/Helpers/GetLogEntrySound";
import { ESharedComponent } from "source/app/services/UI/State/ESharedComponent";
import { State } from "source/app/services/UI/State/State";
import { IsMobileDevice } from "../../../../../domain/Device/Helpers/IsMobile";

export const OrchestrateEffects = () => {
    AutoDefocusLogInputEntry();

    if (IsMobileDevice()) {
        return;
    }

    const logInputForm = State.ReadClass<ILogInputFormState>(
        ESharedComponent.LogInputForm
    );

    const isOrchestrationRunning = logInputForm.state.isOrchestrationRunning;

    if (isOrchestrationRunning) {
        return;
    }

    logInputForm.setState({ isOrchestrationRunning: true }, () => {
        OrchestrateSounds();
    });
};

/**
 * Prevents repeated orchestrations from kicking in
 */
function AutoDefocusLogInputEntry() {
    setTimeout(() => jQuery(`#target_logInputEntryText`).blur(), 30000);
}

function OrchestrateSounds() {
    var logEntrySound = SetLogEntrySound();
    logEntrySound.Play();

    const { currentMusicSoundFile } = State.ReadClass<IMusicMenuState>(
        ESharedComponent.MusicMenu
    ).state;

    if (!currentMusicSoundFile) {
        return;
    }

    // setTimeout(() => FadeOutRadio(), 3000);
    setTimeout(() => currentMusicSoundFile.FadeOut(0, 6000), 3000);
    setTimeout(() => Ambience.FadeOut(), 5000);

    setTimeout(() => Ambience.FadeIn(SetIsOrchestrationRunningToFalse), 23000);
    // setTimeout(() => FadeInRadio(SetIsOrchestrationRunningToFalse), 26000);

    setTimeout(
        () =>
            currentMusicSoundFile.FadeIn(
                0,
                1,
                5000,
                SetIsOrchestrationRunningToFalse
            ),
        26000
    );
}

const SetIsOrchestrationRunningToFalse = () => {
    const logInputForm = State.ReadClass<ILogInputFormState>(
        ESharedComponent.LogInputForm
    );

    logInputForm.setState({ isOrchestrationRunning: false });
};
